import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { useWindowSize } from '../../../libs/hooks'
import { CloseIcon, TabsArrowRight } from '../../../icons'
import Dropdown from '../../common/Dropdown'
import TooltipedIcon from '../../common/TooltipedIcon'
import RegisteredDevicesReports from './RegisteredDevicesReports'
import GeographicalConnectionReports from './GeographicalConnectionReports'
import SoldUnitsConnectionReports from './SoldUnitsConnectionReports'
import RemoteAccessConnectionReports from './RemoteAccessConnectionReports'
import DeviceSoftwareVersionReports from './DeviceSoftwareVersionReports'
import '../internal-reports.scss'

const DevicesReports = (props) => {
  const { t } = useTranslation()
  const isMobile = useWindowSize()[0] <= 768
  const [availablePages, setAvailablePages] = useState([])
  const [selectedPage, setSelectedPage] = useState(null)
  const [menuOpen, setMenuOpen] = useState(true)
  const deviceReportPages = [
    {
      key: 0,
      title: 'reports.registered_devices',
      content: <RegisteredDevicesReports />,
      permission: 'page:registered-devices-reports',
    },
    {
      key: 1,
      title: 'reports.geographical_connection',
      content: <GeographicalConnectionReports />,
      permission: 'page:geographical-devices-reports',
    },
    {
      key: 2,
      title: 'reports.sold_units_connection',
      content: <SoldUnitsConnectionReports />,
      permission: 'page:sold-devices-reports',
    },
    {
      key: 3,
      title: 'reports.remote_access_connection',
      content: <RemoteAccessConnectionReports />,
      permission: 'page:remote-access-reports',
    },
    {
      key: 5,
      title: 'reports.software_version_reports',
      content: <DeviceSoftwareVersionReports />,
      permission: 'page:firmware-versions-reports',
    },
  ]

  useEffect(() => {
    let accessAllowedPages = []

    const permissionArr = props.userPermissions ? (Array.isArray(props.userPermissions) ? props.userPermissions : Object.values(props.userPermissions)) : []
    accessAllowedPages = deviceReportPages.filter((page) => permissionArr.includes(page.permission?.toLowerCase()))

    setAvailablePages(accessAllowedPages)
    setSelectedPage(accessAllowedPages[0] || null)
  }, [props.userPermissions])

  useEffect(() => {
    if (selectedPage) {
      setTimeout(() => window.dispatchEvent(new Event('resize')), 100)
    }
  }, [selectedPage])

  const handleMenuClick = (page) => setSelectedPage(page)

  return (
    <div className={`internal-reports-wrapper internal-reports-layout${!menuOpen ? ' menu-collapsed' : ''}`}>
      {isMobile && (
        <div className="reports-mobile-dropdown">
          <Dropdown
            className="dropdown-input"
            options={availablePages.map((page) => ({
              key: String(page.key),
              value: t(page.title),
            }))}
            initialSelectedKey={selectedPage ? String(selectedPage.key) : ''}
            onChange={(option) => {
              const page = availablePages.find((p) => String(p.key) === option.key)
              setSelectedPage(page)
            }}
          />
        </div>
      )}
      {!isMobile && (
        <div className="reports-menu">
          <div className="collapse-toggle" onClick={() => setMenuOpen((prev) => !prev)}>
            {menuOpen && <div className="reports-title">{t('reports.select_report')}</div>}
            {menuOpen ? <CloseIcon /> : <TooltipedIcon icon={<TabsArrowRight />} tooltipText={t('reports.select_report')} />}
          </div>
          {menuOpen && (
            <div className="menu-list">
              {availablePages.map((page) => (
                <div key={page.key} className={`menu-item${selectedPage?.key === page.key ? ' selected' : ''}`} onClick={() => handleMenuClick(page)}>
                  {t(page.title)}
                </div>
              ))}
            </div>
          )}
        </div>
      )}
      <div className="reports-content">{selectedPage?.content}</div>
    </div>
  )
}

function mapStateToProps({ userPermissions }) {
  return {
    userPermissions,
  }
}

export default connect(mapStateToProps)(DevicesReports)

